import cn from 'classnames'

import styles from './styles.module.scss'

import DotGridIcon from './icons/dot grid.svg'
import ExchangeArrowsIcon from './icons/exchange arrows.svg'
import StarButtomIcon from './icons/star buttom.svg'
import StarTopIcon from './icons/star top.svg'
import TrianglesIcon from './icons/triangles.svg'
import WiuWiuIcon from './icons/wiu-wiu.svg'
import ExchangeCalculator from './exchange-calculator'
import { useTranslation } from 'utils/use-translation'

export default function ExchangeCrypto() {
  const { t } = useTranslation()

  return (
    <section className={styles['exchange-crypto']}>
      <div className={styles['exchange-crypto__left']}>
        <div className={styles['exchange-crypto__title']}>
          <h1>{t('exchange_crypto')}</h1>
        </div>

        <div className={styles.exchangeDescription}>
          <p className={styles['exchange-crypto__subtitle']}>
            {t('calculate_cryptocurrency_exchange')}
          </p>
          <img className={styles['exchange-crypto__dot-grid']} src={DotGridIcon} alt="dot grid icon" />
          <img className={styles['exchange-crypto__exchange-arrows']} src={ExchangeArrowsIcon} alt="exchange arrows icon" />
        </div>
      </div>

      <div className={styles['exchange-crypto__right']}>
        <div className={styles.calculator}>
          <ExchangeCalculator />
          <img className={styles['exchange-crypto__star-buttom']} src={StarButtomIcon} alt="star buttom icon" />
          <img className={styles['exchange-crypto__triangles']} src={TrianglesIcon} alt="triangles icon" />
          <img className={styles['exchange-crypto__wiu-wiu']} src={WiuWiuIcon} alt="wiu wiu icon" />
          <img
            className={cn(styles['exchange-crypto__star-top'], styles.mobile)}
            src={StarTopIcon}
            alt="star top icon"
          />
        </div>
      </div>

      <img className={cn(styles['exchange-crypto__star-top'], styles.desktop)} src={StarTopIcon} alt="star top icon" />
    </section>
  )
}
